<template>
    <aside id="active-chats-panel" :class="['theme-' + selectedTheme, {'rolled-out': isRolledOut}]">
        <div>
            <group-details v-if="activeChatType === 'group'"></group-details>
            <user-chats></user-chats>
        </div>
    </aside>
</template>

<script>

	import UserChats from './ChatSidePanelWidgets/UserChats.vue';
	import GroupDetails from './ChatSidePanelWidgets/GroupDetails.vue';

	export default {
		name: 'ActiveChatsPanel',
		components: {
			'user-chats': UserChats,
			'group-details': GroupDetails
		},

		computed: {
			activeChatId(){
				return this.$store.state.activeChatModel.id;
			},

			activeChatType(){
				return !this.activeChatId ? '' : this.activeChatId.split('.')[0];
			},

			selectedTheme(){
				return this.$store.state.loggedUserModel.info.theme
			},

			isRolledOut(){
				return this.$store.state.chatroomConfigModel.fullSidePanelMode;
			}
		}

	}
</script>


// WEBPACK FOOTER //
// ActiveChatsPanel.vue?5afaa30a